import 'containers/Stepper/Stepper.css';

import type { LoadingState } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type { NodeSn } from '@ipfabric/utils';
import { NavTabsWrapper } from 'components/NavTabs/NavTabsWrapper';
import { TabContent } from 'components/NavTabs/TabContent';
import {
  type ContinueDiscoveryEvent,
  SnapshotCreationDeviceSettings,
  type SnapshotCreationDeviceSettingsRowData,
  type SourceSelectEvent,
} from 'components/SnapshotCreation/SnapshotCreationDeviceSettings';
import { useLocale } from 'containers/App/LocaleContext';
import { StepperItem } from 'containers/Stepper';
import type { FC } from 'react';
import type { TaskApiSourceMap } from './SnapshotCreationTable';
import type { RequestErrors } from './useSnapshotCreation';

interface Props {
  breadcrumbsStep: number;
  onBreadcrumbsStep1Click: () => void;
  failedData: SnapshotCreationDeviceSettingsRowData[];
  onContinueDiscovery: (event: ContinueDiscoveryEvent) => void;
  onSnapshotSettingsOpen: (settingsTab: string) => void;
  onSourceSelect: (event: SourceSelectEvent) => void;
  requestErrors: RequestErrors;
  selectedSns: NodeSn[];
  sendingDataState: LoadingState;
  taskApiSourceMap: TaskApiSourceMap | null;
}

export const SnapshotCreationNextStep: FC<Props> = (props) => {
  const {
    snapshotCreation: { nextStep: nextStepMsg },
  } = useLocale();

  if (props.breadcrumbsStep !== 2) {
    return null;
  }

  return (
    <NavTabsWrapper fullHeight className='nav-tabs-custom'>
      <div className='stepper my-3 mr-3'>
        <StepperItem
          completed
          count={1}
          currentStep={props.breadcrumbsStep}
          first
          linkTo='#'
          onClick={props.onBreadcrumbsStep1Click}
        >
          {nextStepMsg.stepper.snapshotCreation}
        </StepperItem>
        <StepperItem
          completed={false}
          count={2}
          currentStep={props.breadcrumbsStep}
          linkTo=''
        >
          {nextStepMsg.stepper.discoverySettings}
        </StepperItem>
        <StepperItem
          completed={false}
          count={3}
          currentStep={props.breadcrumbsStep}
          last
          linkTo=''
        >
          {nextStepMsg.newSnapshot}
        </StepperItem>
      </div>
      {/* Override AdminLTE's 15px padding*/}
      <TabContent className='!p'>
        <SnapshotCreationDeviceSettings
          failedData={props.failedData}
          onBackBtnClick={props.onBreadcrumbsStep1Click}
          onContinueDiscovery={props.onContinueDiscovery}
          onSnapshotSettingsOpen={props.onSnapshotSettingsOpen}
          onSourceSelect={props.onSourceSelect}
          requestErrors={props.requestErrors}
          selectedSns={props.selectedSns}
          sendingDataState={props.sendingDataState}
          taskApiSourceMap={props.taskApiSourceMap}
        />
      </TabContent>
    </NavTabsWrapper>
  );
};
